module.exports = new __parcel__URL__("luigis-mansion-dark-moon.b8ded8b0.jpg").toString();